module.exports = __webpack_public_path__ + "img/square-table-3.f75d32e4.png";